import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "@/pages/home/components/HeroSection";
import LiveTicker from "@/pages/home/components/LiveTicker";
import LatestFlow from "@/pages/home/components/LatestFlow";
import HotRanking from "@/pages/home/components/HotRanking";
import CommentVibe from "@/pages/home/components/CommentVibe";
import TopicSection from "@/pages/home/components/TopicSection";
import SubscribeForm from "@/pages/home/components/SubscribeForm";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteNavbar />
      <main className="w-full flex-1">
        <HeroSection />
        <LiveTicker />
        <LatestFlow />
        <HotRanking />
        <CommentVibe />
        <TopicSection />
        <SubscribeForm />
      </main>
      <SiteFooter />
    </div>
  );
}